import home from './home/routes';
import detail from './detail/routes';

export default [home, detail];
